import React, { Component } from 'react'
import { UserStatusEnum } from '../../../../enums';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"
import { Input } from '@/components/ui/input';
import { Formik } from 'formik';
import { AdminUsersSearch } from './AdminUsersSearchBar';
import { Button } from '@/components/ui/button';

interface IProps {
    searchTerm?: string;
    status?: UserStatusEnum | '*';
    onSearchChanged: (filter: AdminUsersSearch) => void;
}

export class AdminUsersSearchBarForm extends Component<IProps> {
    render() {
        return (
            <Formik initialValues={{
                searchTerm: this.props.searchTerm || '',
                status: this.props.status || '*',
            }}
                initialStatus="none"
                validate={() => {
                    const errors = {} as AdminUsersSearch;
                    return errors;
                }}
                onSubmit={(values, actions) => {
                    actions.setStatus('sending');
                    this.props.onSearchChanged({
                        searchTerm: values.searchTerm,
                        status: values.status || '*',
                    });
                    actions.setStatus('sent');
                    actions.setSubmitting(false);
                }}>
                {
                    ({ handleSubmit, isSubmitting, handleChange, values, setFieldValue }) => (
                        <form className="flex items-center flex-col md:flex-row gap-2 w-full" noValidate onSubmit={handleSubmit}>
                            <Input
                                placeholder="Buscar..."
                                name="searchTerm"
                                className="md:max-w-sm w-full"
                                value={values.searchTerm}
                                onChange={handleChange}
                            />

                            <Select
                                name="status"
                                value={values.status}
                                onValueChange={val => setFieldValue("status", val)}
                            >
                                <SelectTrigger className="md:w-[180px] w-full">
                                    <SelectValue placeholder="Estatus" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="*">- Todos -</SelectItem>
                                    <SelectItem value={UserStatusEnum.ENABLED}>Aprobado</SelectItem>
                                    <SelectItem value={UserStatusEnum.DISABLED}>Deshabilitado</SelectItem>
                                    <SelectItem value={UserStatusEnum.VERIFICATION}>En verificación</SelectItem>
                                </SelectContent>
                            </Select>

                            <Button className="w-full md:w-auto" disabled={isSubmitting} type="submit">Buscar</Button>
                        </form>
                    )
                }
            </Formik>
        )
    }
}
